import { isDefined } from '@sgme/fp';
import { Action } from 'state/actions';
import { StreamingPriceMap, StreamingPriceModel } from 'state/quotes/streaming/streaming.model';
import { addOrPatchKey, patchKeyIfExist, removeKey } from 'state/utils/collection';

export function streamingPriceReducer(state: StreamingPriceMap = {}, action: Action) {
  switch (action.type) {
    case 'STREAM_REQUESTED':
      return removeKey(state, action.tabId);
    case 'STREAMING_CANCELLED':
      if (action.quoteType === 'Indicative') {
        return patchKeyIfExist(state, action.tabId, s => ({ ...s, greeks: undefined }) as StreamingPriceModel);
      }
      return state;
    case 'QUOTE_STREAMING_TRADE_DONE':
      return patchKeyIfExist(state, action.tabId, prices => {
        const { isin, vlr, wkn } = action;
        if (isDefined(prices[action.quoteSequenceId])) {
          return {
            [action.quoteSequenceId]: {
              ...prices[action.quoteSequenceId],
              remainingValues: { ...prices[action.quoteSequenceId].remainingValues, isin, vlr, wkn },
            },
          };
        } else {
          return {};
        }
      });
    case 'STREAMING_PRICE_RECEIVED':
      return addOrPatchKey(state, action.tabId, prices => ({
        ...prices,
        [action.quoteSequenceId]: action,
      }));
  }
  return state;
}
